import SearchSm from "@untitled-ui/icons-react/build/esm/SearchSm";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import { CheckIcon } from "../../../../../assets/icons";
import { ChevronDown } from "../../../../../assets/icons/chevronDown";
import "./index.scss";

export interface SearchOption {
  label: string;
  value: string;
}

interface SearchSelectProps {
  options: SearchOption[];
  value: string | null;
  onSelect: (value: string) => void;
  onSearch: (text: string) => void;
  loading?: boolean;
  placeholder?: string;
  className?: string;
}

export const SearchSelect = ({
  options,
  value,
  onSelect,
  onSearch,
  loading = false,
  placeholder = "Digite para buscar...",
  className = "",
}: SearchSelectProps) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState(value || "");
  const [isTyping, setIsTyping] = useState(false);

  const selectedLabel =
    options.find((o) => o.value === value)?.label ?? value ?? "";

  useEffect(() => {
    if (!isTyping) {
      setQuery(selectedLabel);
    }
  }, [value, selectedLabel, isTyping]);

  const displayedValue = isTyping ? query : selectedLabel;

  return (
    <Dropdown className={`search-select ${className}`} show={open}>
      <InputGroup
        className="search-select-input-wrapper"
        onClick={() => {
          setOpen(true);
          setIsTyping(true);
        }}
      >
        <InputGroup.Text>
          <SearchSm color="#667085" />
        </InputGroup.Text>

        <Form.Control
          type="text"
          placeholder={placeholder}
          value={displayedValue}
          onChange={(e) => {
            const text = e.target.value;
            setQuery(text);
            setIsTyping(true);
            onSearch(text);
            onSelect(text);
            setOpen(text.length >= 3);
          }}
          onFocus={() => {
            setIsTyping(true);
            setOpen(true);
          }}
          onBlur={() => {
            setIsTyping(false);
            setQuery(selectedLabel);
            setOpen(false);
          }}
          className="search-input"
        />

        <button
          className={classNames("chevron-btn", open ? "open" : "")}
          onClick={(e) => {
            e.stopPropagation();
            setOpen((prev) => !prev);
            setIsTyping(false);
            setQuery(selectedLabel);
          }}
        >
          <ChevronDown />
        </button>
      </InputGroup>

      {open && (
        <Dropdown.Menu className="search-select-menu show">
          {query.length < 3 && !selectedLabel && (
            <div className="search-select-info">
              Digite pelo menos 3 letras...
            </div>
          )}

          {query.length >= 3 && loading && (
            <div className="search-select-info">Buscando...</div>
          )}

          {query.length >= 3 && !loading && options.length === 0 && (
            <div className="search-select-info">
              Nenhum resultado encontrado
            </div>
          )}

          {!loading &&
            query.length >= 3 &&
            options.map((opt) => (
              <Dropdown.Item
                key={opt.value}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  onSelect(opt.value);
                  setQuery(opt.label);
                  setIsTyping(false);
                  setOpen(false);
                }}
                active={value === opt.value}
              >
                {value === opt.value && <CheckIcon />}
                {opt.label}
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};
